
import { Building2, Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center space-x-2 mb-6">
                <Building2 className="h-8 w-8 text-blue-400" />
                <span className="text-2xl font-bold">RentFlow</span>
              </div>
              <p className="text-gray-300 mb-6 max-w-md">
                The smartest way to manage your rental properties. Streamline operations, 
                increase efficiency, and grow your business with our comprehensive platform.
              </p>
            </div>
            
            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-6">Product</h3>
              <ul className="space-y-3">
                <li><a href="#benefits" className="text-gray-300 hover:text-blue-400 transition-colors">Features</a></li>
                <li><a href="#pricing" className="text-gray-300 hover:text-blue-400 transition-colors">Pricing</a></li>
              </ul>
            </div>
            
            {/* Legal & Access */}
            <div>
              <h3 className="text-lg font-semibold mb-6">Quick Access</h3>
              <ul className="space-y-3">
                <li><Link to="/privacy" className="text-gray-300 hover:text-blue-400 transition-colors">Privacy Policy</Link></li>
                <li><Link to="/terms" className="text-gray-300 hover:text-blue-400 transition-colors">Terms of Service</Link></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-12 pt-8">
            <div className="flex flex-col items-center space-y-4">
              <a 
                href="mailto:support@rentflow.space" 
                className="flex items-center space-x-3 text-gray-300 hover:text-blue-400 transition-colors"
              >
                <Mail className="h-5 w-5 text-blue-400" />
                <span>support@rentflow.space</span>
              </a>
              <p className="text-gray-400 text-sm">
                © 2025 RentFlow. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
